package ui.component.buttons

import emotion.react.css
import react.FC
import react.Props
import react.ReactNode
import react.Suspense
import react.dom.html.ReactHTML
import ui.styles.Styles
import ui.styles.icons.HandlerSVGProps
import ui.styles.icons.IconsSVG
import web.cssom.px

external interface MiniIconButtonProps : Props {
    var onClick: () -> Unit
    var realIconSVG: IconsSVG?
//    var plusMessageLeft: String?
//    var plusMessageRight: String?
}

val miniIconButton = FC<MiniIconButtonProps>{props->

    val description = props.realIconSVG?.description ?: "_i_"
    val icon = props.realIconSVG?.iconSVG ?: FC<HandlerSVGProps>{  }


    ReactHTML.button{
        className = Styles.Buttons.miniIconButton

        title = description

        onClick = {_->
            props.onClick()
        }

//        if (props.plusMessageLeft != null) {
//            ReactHTML.a{
//                css {
//                    paddingRight = 10.px
//                }
//                +props.plusMessageLeft
//            }
//        }

        Suspense{
            this.fallback = ReactNode("__")
            icon()
        }

//        if (props.plusMessageRight != null) {
//            ReactHTML.a{
//                css {
//                    paddingLeft = 10.px
//                }
//                +props.plusMessageLeft
//            }
//        }
    }
}